export enum AgentTools {
  // Salesforce
  sf_object_discover = 'sf_object_discover',
  sf_field_discover = 'sf_field_discover',
  sf_get_sobject = 'sf_get_sobject',
  sf_get_org_limits = 'sf_get_org_limits',
  sf_get_list_views = 'sf_get_list_views',
  sf_get_recent_items = 'sf_get_recent_items',
  sf_soql_query = 'sf_soql_query',
  sf_sosl_search = 'sf_sosl_search',
  sf_query_all = 'sf_query_all',
  sf_create_record = 'sf_create_record',
  sf_update_record = 'sf_update_record',
  sf_delete_record = 'sf_delete_record',
  // Chorus
  chorus_search_engagements = 'chorus_search_engagements',
  chorus_get_engagement_details = 'chorus_get_engagement_details',
  chorus_get_transcript = 'chorus_get_transcript',
  chorus_summarize_transcript = 'chorus_summarize_transcript',
}

export enum MessagePartType {
  ToolCall = 'tool_call',
  ToolResponse = 'tool_response',
}

export enum ChorusTools {
  chorus_search_engagements = 'chorus_search_engagements',
  chorus_get_engagement_details = 'chorus_get_engagement_details',
  chorus_get_transcript = 'chorus_get_transcript',
  chorus_summarize_transcript = 'chorus_summarize_transcript',
}

export interface ToolCall<TName extends AgentTools, TArgs = object> {
  name: TName;
  args: TArgs;
  id: string;
  type: MessagePartType.ToolCall;
}

interface PendingToolCall<TName extends AgentTools = AgentTools, TArgs = object>
  extends ToolCall<TName, TArgs> {
  isRunning: true;
}

interface ToolCallWithResults<TName extends AgentTools = AgentTools, TArgs = object>
  extends ToolCall<TName, TArgs> {
  results: string;
  isRunning: false;
}

export type ToolCallSummary<TName extends AgentTools = AgentTools, TArgs = object> =
  | PendingToolCall<TName, TArgs>
  | ToolCallWithResults<TName, TArgs>;
